<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" class="mt-5 pb-2">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="342" height="103"
          viewBox="0 0 342 103">
          <defs>
            <pattern id="pattern" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 707 214">
              <image width="707" height="214"
                xlink:href="data:image/png;base64,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" />
            </pattern>
          </defs>
          <rect id="アセット_64_2x" data-name="アセット 64@2x" width="342" height="103" fill="url(#pattern)" />
        </svg>
      </v-col>
    </v-row>


    <v-row class="text-center pl-5 pr-5" v-if="nowMissionChapter >= 6">
      <v-col class="pa-0 ma-0">
        <v-btn text color="white" @click="scrollToAnchorPoint('photo')">
          <v-icon size="16px">mdi-gift</v-icon>&nbsp;
          <span style="text-decoration:underline;">フォトフレーム</span>
        </v-btn>
      </v-col>
      <v-col class="pa-0 ma-0">
        <v-btn text color="white" @click="scrollToAnchorPoint('sticker')">
          <v-icon size="16px">mdi-gift</v-icon>&nbsp;
          <span style="text-decoration:underline;">映画オリジナルステッカー</span>
        </v-btn>
      </v-col>
    </v-row>


    <v-row class="text-center pt-15 mt-10" v-if="nowMissionChapter >= 6">
      <v-col cols="12" class="pt-0 mt-0 pl-5 pr-5 pb-0 text-pink">
        貞子と撮影！
      </v-col>
      <v-col cols="12" class="pt-1 pb-1" style="font-size:2.4em;font-weight: bold;color:#F5F2DB !important;"
        ref="photo">
        フォトフレーム
      </v-col>
      <v-col cols="12" class="pt-7 pb-3">
        <div class="photoframe text-center">
          <img src="/images/present_preimage.jpg" width="80%" style="border:4px solid #D9E9E5;margin:0 auto;">
        </div>
      </v-col>
      <v-col cols="12" class="text-left pt-2 pl-12 pr-12">
        記念フォトフレームで貞子とユネッサンでの思い出を残そう !
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn class="btn_blue" @click="viewDialogShot = true">写真を撮る</v-btn>
      </v-col>
    </v-row>

    <v-row class="text-center pt-15 mt-15" v-if="nowMissionChapter >= 6">
      <v-col cols="12" class=" pt-15 mt-15 pl-5 pr-5 text-pink">
        先着300名様限定 !
      </v-col>
      <v-col cols="12" class="text-center mb-7" style="font-size:2.4em;font-weight: bold;color:#F5F2DB !important;"
        ref="sticker">
        映画オリジナル<br />ステッカー
      </v-col>
      <v-col cols="12" class="pl-12 pr-12">
        <v-img src="/images/present_sticker.png"></v-img>
      </v-col>
      <v-col cols="12" class="text-left pl-12 pr-12">
        出口カウンターでこの画面を見せると、映画オリジナルステッカーがもらえます。絵柄はランダムです。なくなり次第終了となりますのでご了承ください。
      </v-col>
      <v-col cols="12" class="pt-15 pl-12 pr-12">
        <v-img src="/images/present_counter.jpg"></v-img>
      </v-col>
      <v-col cols="12" class="text-left pl-12 pr-12 pb-10">
        洋服に着替えてから、出口にあるこのカウンターで受け取ってください。<br />
        ※受付時間は20時までです。
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="text-center mt-15 mb-15 pb-15">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="80%"
          viewBox="0 0 293.417 57.134" @click="goTop">
          <defs>
            <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
              <stop offset="0" stop-color="#ff009c" />
              <stop offset="1" />
            </linearGradient>
            <clipPath id="clip-path">
              <path
                d="M9.992,28.067a3.216,3.216,0,1,1,3.216,3.217,3.221,3.221,0,0,1-3.216-3.217m264,0a3.217,3.217,0,1,1,3.217,3.217,3.221,3.221,0,0,1-3.217-3.217M21.567.284.354,28.567,21.567,56.851H271.85L293.063,29.07,271.852.284Z"
                fill="url(#linear-gradient)" />
            </clipPath>
            <clipPath id="clip-path-2">
              <rect id="長方形_1271" data-name="長方形 1271" width="293.417" height="57.134" transform="translate(0 0)"
                fill="none" />
            </clipPath>
          </defs>
          <g transform="translate(-67 -805)">
            <g>
              <g>
                <g transform="translate(67 805)">
                  <g clip-path="url(#clip-path)">
                    <rect id="長方形_1270" data-name="長方形 1270" width="292.709" height="56.567"
                      transform="translate(0.354 0.284)" fill="url(#linear-gradient)" />
                  </g>
                </g>
                <g transform="translate(67 805)">
                  <g clip-path="url(#clip-path-2)">
                    <path
                      d="M271.709.567l21,28.5-21,27.5h-250l-21-28,21-28Zm5.5,31a3.5,3.5,0,1,0-3.5-3.5,3.5,3.5,0,0,0,3.5,3.5m-264,0a3.5,3.5,0,1,0-3.5-3.5,3.5,3.5,0,0,0,3.5,3.5M271.995,0H21.426l-.17.227-21,28L0,28.567l.256.34,21,28,.17.227H271.989l.171-.223,21-27.5.258-.338-.252-.342-21-28.5Zm5.214,31a2.933,2.933,0,1,1,2.933-2.933A2.937,2.937,0,0,1,277.209,31m-264,0a2.933,2.933,0,1,1,2.933-2.933A2.937,2.937,0,0,1,13.209,31"
                      fill="#d20080" />
                  </g>
                </g>
              </g>
            </g>
            <text id="TOPへ" transform="translate(214 841)" fill="#fff" font-size="18"
              font-family="ShipporiMinchoB1-Bold, Shippori Mincho B1" font-weight="700" letter-spacing="0.05em">
              <tspan x="-30.996" y="-3">TOPへ</tspan>
            </text>
          </g>
        </svg>

      </v-col>
    </v-row>

    <!---------------------->
    <v-dialog v-model="viewDialogShot" max-width="400">
      <v-card>
        <div class="text-right mr-1">
          <v-icon @click="viewDialogShot = false">mdi-close</v-icon>
        </div>
        <v-card-text class="dialogText">
          <v-row class="pa-0">
            <v-col cols="12" class="text-center" v-show="!isArchives">
              <img ref="capImage" width="100%" src="/images/yunessan_frame.png" style="background-color:#aaa" />
              <div class="text-right">
                <v-icon size="2em" class="ma-0 pa-0" @click="switchCamera">mdi-camera-flip-outline</v-icon>
              </div>
            </v-col>

            <v-col cols="12" class="text-center" v-show="isArchives">
              <img ref="shotImage" width="100%" />
            </v-col>

            <v-col cols="12" class="text-center mt-0 pt-0" v-if="!isArchives">
              <v-btn width="80%" class="btn_blue" :disabled="!isActiveCamera" @click="execShot">撮影する</v-btn>
            </v-col>

            <v-col cols="12" class="text-center" v-if="isArchives && sendShotStatus == 9">
              <v-alert type="error">
                <span>送信できませんでした。<br />再度お試しください。</span>
              </v-alert>
            </v-col>

            <v-col cols="6" class="text-center" v-if="isArchives">
              <v-btn width="100%" class="btn_blue" @click="isArchives = false">もう一度撮影</v-btn>
            </v-col>
            <v-col cols="6" class="text-center" v-if="isArchives">
              <div v-if="isLineApp">
                <v-btn width="80%" :disabled="sendShotStatus != 0 && sendShotStatus != 9" class="btn_blue"
                  @click="saveShot">
                  <div v-if="sendShotStatus == 0">画像を保存</div>
                  <div v-else-if="sendShotStatus == 1" class="loader"></div>
                  <div v-else-if="sendShotStatus == 2">保存しました</div>
                  <div v-else-if="sendShotStatus == 9">再保存する</div>
                </v-btn>
                ※LINEに送られます
              </div>
              <div v-else class="text-left">
                画像を長押しや右クリックで保存できます。
              </div>

            </v-col>


          </v-row>

        </v-card-text>
      </v-card>
    </v-dialog>
    <!---------------------->
  </v-container>
</template>
<style scoped>
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}

.loader {
  font-size: 2px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #ffffff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.prephoto {
  margin: 0 auto;
  transform: rotate(5deg);
  border: 3px solid white;
}

.barstyle {
  margin: 0 auto;
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: .5;
}

.barstyle:before {
  content: '';
  background: linear-gradient(to right, transparent, #aaa, transparent);
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}

.barstyle:after {
  content: attr(data-content);
  position: relative;
  display: inline-block;
  color: black;
  padding: 0 .5em;
  line-height: 1.5em;
  color: #aaa;
  background-color: #fcfcfa;
}
</style>
<script>
import axios from "axios";
export default {
  data: () => ({
    // viewDialogInfo: false,
    viewDialogShot: false,
    shotCamera: null,
    isArchives: false,
    arcivesBase64: null,
    sendShotStatus: 0,
    isActiveCamera: false
  }),
  created: function () {
    this.viewDialogShot = false;
    this.isArchives = false;
    this.isActiveCamera = false;
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$route.params.go) {
        setTimeout(() => {
          this.scrollToAnchorPoint(this.$route.params.go)
        }, 500);
      }
    })
  },

  destroyed: function () {
    this.arcivesBase64 = null;
  },
  methods: {
    goTop() {
      this.$router.push('/top');
    },
    async viewShot(count, func) {
      if (!count) count = 1;
      if (this.$refs.capImage) {
        try {
          this.isActiveCamera = false;
          await this.$stamp.shotCamera(this.$refs.capImage, "/images/yunessan_frame.png", () => {
            this.isActiveCamera = true;
          });
        } catch (error) {
          console.error(error);
          this.$router.push({ name: 'error', params: { 'errormessage': "カメラなどのデバイスの利用ができません。" } });
        }
      } else if (count < 5) {
        setTimeout(() => {
          this.viewShot(count + 1, func)
        }, 300);
      }
    },
    switchCamera() {
      this.isActiveCamera = false;
      this.$stamp.switchCamera(() => {
        this.isActiveCamera = true;
      });
    },
    execShot() {
      try {
        this.arcivesBase64 = this.$stamp.getShotCameraData();
        if (!this.arcivesBase64) throw new Error("not image");
        this.sendShotStatus = 0;
        this.isArchives = true;
        this.viewArchiveShot();
        gtag('event', 'photoframe', { 'event_category': 'shot', 'event_label': this.nowMission });
      } catch (error) {
        console.error(error);
      }
    },
    viewArchiveShot(count) {
      if (!count) count = 1;
      if (this.$refs.shotImage) {
        this.$refs.shotImage.src = this.arcivesBase64;
      } else if (count < 5) {
        setTimeout(() => {
          this.viewArchiveShot(count + 1)
        }, 300);
      }
    },
    async saveShot() {
      this.sendShotStatus = 1;
      try {
        gtag('event', 'photoframe', { 'event_category': 'save', 'event_label': this.nowMission });
        // console.log("PHOTO SEND START");
        let res = await axios.post(
          process.env.VUE_APP_SERVER_SAVE_PATH + 'photo',
          {
            'service': process.env.VUE_APP_SERVER_SERVICE_ID,
            'lineUserHashKey': this.$store.getters.lineUserHashKey,
            'localUserId': this.$store.getters.localUserId,
            'image': this.arcivesBase64
          });

        // console.log("PHOTO SEND SERVER", res);
        if (res.data.error) {
          throw new Error('not save image');
        }
        await liff.sendMessages([
          {
            type: 'text',
            text: '撮影した写真はこれだよ！'
          },
          {
            "type": "image",
            "originalContentUrl": res.data.path,
            "previewImageUrl": res.data.path
          },
        ])
        // console.log("PHOTO LINE SEND OK");
        this.sendShotStatus = 2;
      } catch (error) {
        console.error("PHOTO ERROR", error);
        this.sendShotStatus = 9;
      }
    },
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth' })
    }
  },
  computed: {
    nowMissionSection() {
      return this.$store.getters.nowMissionSection;
    },
    nowMissionChapter() {
      return this.$store.getters.nowMissionChapter;
    },
    nowMission() {
      return this.$store.getters.nowMissionChapter + "-" + this.$store.getters.nowMissionSection;
    },
    isLineApp() {
      return typeof (this.$store.getters.lineUserHashKey) == "string"
    }
  },
  watch: {
    viewDialogShot(newVal) {
      // console.log("viewDialogShot", this.viewDialogShot)
      if (newVal) {
        this.viewShot();
      } else {
        this.$stamp.stopCamera();
      }
    }
  }
};
</script>

